import { FC } from "react";
import { AirplaneIcon } from "src/assets/Icons";
import { RowSeat, SeatType } from "src/Modules/Flights/constants/JourneyDetails";
import ColumnHeader from "../components/ColumnHeader/ColumnHeader";
import RowSeating from "../components/RowSeating/RowSeating";

interface PlaneSeatingWebProps {
  colMap: Map<number, string>;
  rows?: RowSeat[];
  craftType?: string;
  reservedSeats: string[];
  onClick: (val: SeatType) => void;
  flightId?: string | number;
}

const PlaneSeatingScroll: FC<PlaneSeatingWebProps> = ({ colMap, rows, craftType, reservedSeats, onClick, flightId }) => {
  return (
    <div className="flex flex-col gap-5 rounded-[100px] bg-background-default p-2 py-10 overflow-hidden shadow-md">
      <div className="flex w-full flex-col items-center justify-center text-sm text-font-minimal shrink-0">
        <AirplaneIcon className="h-5 w-5" transform="rotate(-90)" />
        <span>{craftType}</span>
      </div>
      <div className="flex w-full flex-1 flex-col items-[safe_center] px-4 gap-2 md:gap-5 overflow-auto scrollbar-hide">
        <ColumnHeader colMap={colMap} isMobile />

        {rows?.map((row: RowSeat, index: number) => (
          <RowSeating key={`${flightId}-${index}`} colMap={colMap} row={row} onClick={onClick} reservedSeats={reservedSeats} isMobile={true}/>
        ))}
      </div>
    </div>
  );
};

export default PlaneSeatingScroll;
